<template>
  <div id="detail-wrap2">
    <a class="close_btn" @click.prevent="back">
      <span>
        <i class="el-icon-close"></i>
      </span>
    </a>

    <div class="scroll_area" id="js_modal">
      <div class="head_data">
        {{ contract.id }} - {{ contract.surname }} {{ contract.name }}（{{ contract.surname_kana }}
        {{ contract.name_kana }}）
        <span class="badge">{{ contract.contract_status_name }}</span>
      </div>

      <div class="change_wrap" v-if="Object.keys(editUserInputFildes).length">
        <!-- <div class="segment">顧客情報の変更</div> -->
        <SegmentName>顧客情報の変更・ご本人について</SegmentName>
        <div class="table_block">
          <table>
            <tbody>
              <TableTr v-show="editUserInputFildes.applicationDate.isShow">
                <TableTh :isError="false">
                  申込日
                  <RequiredText v-show="editUserInputFildes.applicationDate.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="6" class="u-w--200">
                      <el-select
                        name="application_date_year"
                        placeholder=""
                        v-model="form.application_date_year"
                        @change="onChangeApplicationDate"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.ApplicationYears()"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="4" class="u-w--150">
                      <el-select
                        name="application_date_month"
                        placeholder=""
                        v-model="form.application_date_month"
                        @change="onChangeApplicationDate"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.Months"
                          :key="key"
                          :label="`${item.value}月`"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="4" class="u-w--150">
                      <el-select
                        name="application_date_day"
                        placeholder=""
                        v-model="form.application_date_day"
                        @change="onChangeApplicationDate"
                      >
                        <el-option
                          v-for="(item, key) in applicationDays"
                          :key="key"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-application_date-required"></ErrorMessage>
                  <ErrorMessage class="error-application_date-date"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.purposeOfTransaction.isShow">
                <TableTh :isError="false">
                  取引を行う目的
                  <RequiredText v-show="editUserInputFildes.purposeOfTransaction.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="7" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.purposeOfTransaction.key"
                        v-model="form.purpose_of_transaction"
                        @change="onChangepurposeOfTransaction($event)"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.purposeOfTransaction.choices"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="8" class="u-w--240">
                      <el-input
                        :name="editUserInputFildes.purposeOfTransactionOtherName.key"
                        placeholder=""
                        v-model="form.purpose_of_transaction_other_name"
                        :disabled="form.purpose_of_transaction !== 'その他'"
                        data-validator-name="purpose_of_transaction_other_name_require"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-purpose_of_transaction-required"></ErrorMessage>
                  <ErrorMessage class="error-purpose_of_transaction_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-purpose_of_transaction_other_name-string"></ErrorMessage>
                  <ErrorMessage class="error-purpose_of_transaction_other_name-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.isForeignGovernment.isShow">
                <TableTh :isError="false">
                  外国政府等重要な公的地位にある方等とのお取引に該当する
                  <RequiredText v-show="editUserInputFildes.isForeignGovernment.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="15" class="u-w--400">
                      <InputRadio
                        name="is_foreign_government"
                        :choices="editUserInputFildes.isForeignGovernment.choices"
                        :inputRadioVal.sync="form.is_foreign_government"
                        :handleChange="
                          ($event) => {
                            onChangeIsForeignGovernment($event)
                          }
                        "
                      />
                      <el-input
                        :name="editUserInputFildes.foreignGovernmentCompany.key"
                        v-model="form.foreign_government_company"
                        :disabled="form.is_foreign_government !== 'はい'"
                        :placeholder="editUserInputFildes.foreignGovernmentCompany.placeholder"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-is_foreign_government-required"></ErrorMessage>
                  <ErrorMessage class="error-foreign_government_company-required_if"></ErrorMessage>
                  <ErrorMessage class="error-foreign_government_company-string"></ErrorMessage>
                  <ErrorMessage class="error-foreign_government_company-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.name.isShow">
                <TableTh :isError="false">
                  氏名 漢字
                  <RequiredText v-show="editUserInputFildes.name.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <div class="d-flex flex-shrink-0 mr-2">
                      <el-col class="u-w--50"><FormLabel>姓</FormLabel></el-col>
                      <el-col :span="7" class="u-w--200 flex-shrink-0">
                        <el-input
                          placeholder=""
                          maxlength="10"
                          name="surname"
                          data-validator-name="surname_require"
                          v-model="form.surname"
                          :id="editUserInputFildes.name.surname.key"
                          @input="handleSurnameInput()"
                        />
                      </el-col>
                    </div>
                    <div class="d-flex flex-shrink-0">
                      <el-col class="u-w--50"><FormLabel>名</FormLabel></el-col>
                      <el-col :span="7" class="u-w--200 flex-shrink-0">
                        <el-input
                          placeholder=""
                          maxlength="10"
                          name="first_name"
                          data-validator-name="name_require"
                          v-model="form.first_name"
                          :id="editUserInputFildes.name.firstName.key"
                          @input="handleNameInput()"
                        />
                      </el-col>
                    </div>
                  </el-row>
                  <FormNotice>氏名は必ず全角文字で入力してください</FormNotice>
                  <ErrorMessage class="error-name-required"></ErrorMessage>
                  <ErrorMessage class="error-name-string"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.nameKana.isShow">
                <TableTh :isError="false">
                  氏名 フリガナ
                  <RequiredText v-show="editUserInputFildes.nameKana.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <div class="d-flex flex-shrink-0 mr-2">
                      <el-col class="u-w--50"><FormLabel>セイ</FormLabel></el-col>
                      <el-col :span="7" class="u-w--200 flex-shrink-0">
                        <el-input
                          placeholder=""
                          maxlength="10"
                          name="surname_kana"
                          data-validator-name="surname_kana_require"
                          v-model="form.surname_kana"
                          :id="editUserInputFildes.nameKana.surname.key"
                        />
                      </el-col>
                    </div>
                    <div class="d-flex flex-shrink-0">
                      <el-col class="u-w--50"><FormLabel>メイ</FormLabel></el-col>
                      <el-col :span="7" class="u-w--200 flex-shrink-0">
                        <el-input
                          placeholder=""
                          maxlength="10"
                          name="first_name_kana"
                          data-validator-name="name_kana_require"
                          v-model="form.first_name_kana"
                          :id="editUserInputFildes.nameKana.firstName.key"
                        />
                      </el-col>
                    </div>
                  </el-row>
                  <FormNotice>カナ氏名は必ず全角カタカナ文字で入力してください</FormNotice>
                  <ErrorMessage class="error-name_kana-required"></ErrorMessage>
                  <ErrorMessage class="error-name_kana-string"></ErrorMessage>
                  <ErrorMessage class="error-name_kana-kana"></ErrorMessage>
                  <ErrorMessage class="error-name_kana-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.oldSurname.isShow">
                <TableTh :isError="false">
                  旧姓 または 外国名
                  <RequiredText v-show="editUserInputFildes.oldSurname.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <div class="d-flex flex-shrink-0 mr-2">
                      <el-col class="u-w--50"><FormLabel>漢字</FormLabel></el-col>
                      <el-col class="u-w--460 flex-shrink-0">
                        <el-input
                          placeholder=""
                          maxlength="50"
                          name="old_surname"
                          v-model="form.old_surname"
                          :id="editUserInputFildes.oldSurname.key"
                          @input="handleOldSurnameInput()"
                        />
                      </el-col>
                    </div>
                  </el-row>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <div class="d-flex flex-shrink-0 mr-2">
                      <el-col class="u-w--50"><FormLabel>カナ</FormLabel></el-col>
                      <el-col class="u-w--460 flex-shrink-0">
                        <el-input
                          placeholder=""
                          maxlength="50"
                          name="old_surname_kana"
                          v-model="form.old_surname_kana"
                          :id="editUserInputFildes.oldSurnameKana.key"
                        />
                      </el-col>
                    </div>
                  </el-row>
                  <FormNotice>苗字を1年以内に変更されている場合は必ずご入力ください</FormNotice>
                  <FormNotice>外国名がある場合は必ずご入力ください</FormNotice>
                  <ErrorMessage class="error-old_surname-string"></ErrorMessage>
                  <ErrorMessage class="error-old_surname_kana-string"></ErrorMessage>
                  <ErrorMessage class="error-old_surname_kana-kana"></ErrorMessage>
                  <ErrorMessage class="error-old_surname_kana-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.sexType.isShow">
                <TableTh :isError="false">
                  性別
                  <RequiredText v-show="editUserInputFildes.sexType.required" />
                </TableTh>
                <td>
                  <InputRadio
                    name="sex_type"
                    :choices="editUserInputFildes.sexType.choices"
                    :inputRadioVal.sync="form.sex_type"
                    :handleChange="
                      ($event) => {
                        onChangeSexType()
                      }
                    "
                  />
                  <ErrorMessage class="error-sex_type-required"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.birthday.isShow">
                <TableTh :isError="false">
                  生年月日
                  <RequiredText v-show="editUserInputFildes.birthday.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="6" class="u-w--200">
                      <el-select
                        name="birthday_year"
                        placeholder=""
                        disabled
                        v-model="form.birthday_year"
                        @change="onChangeBirthday()"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.BirthdayYears(has_payment)"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="4" class="u-w--150">
                      <el-select
                        name="birthday_month"
                        placeholder=""
                        disabled
                        v-model="form.birthday_month"
                        @change="onChangeBirthday()"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.Months"
                          :key="key"
                          :label="`${item.value}月`"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="4" class="u-w--150">
                      <el-select
                        name="birthday_day"
                        placeholder=""
                        disabled
                        v-model="form.birthday_day"
                        @change="onChangeBirthday()"
                      >
                        <el-option
                          v-for="(item, key) in birthdayDays"
                          :key="key"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-birthday-required"></ErrorMessage>
                  <ErrorMessage class="error-birthday-date"></ErrorMessage>
                  <ErrorMessage class="error-birthday-birthday_range"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.postNumber.isShow">
                <TableTh :isError="false">
                  郵便番号
                  <RequiredText v-show="editUserInputFildes.postNumber.required" />
                </TableTh>
                <td>
                  <ZipcodeSearch
                    :name="editUserInputFildes.postNumber.key"
                    dataValidationName="post_number_require"
                    :zipcodeVal.sync="form.post_number"
                    :handleBlur="
                      ($event) => {
                        arrangeAddHyphen($event, 'post_number')
                      }
                    "
                    :handleClickSearch="onClickSearchPostNumber"
                  />
                  <FormNotice
                    >例)100-0000 郵便番号がわからない場合は<a
                      href="https://www.post.japanpost.jp/zipcode/"
                      target="_blank"
                      >こちら</a
                    ></FormNotice
                  >
                  <ErrorMessage class="error-post_number-required"></ErrorMessage>
                  <ErrorMessage class="error-post_number-post"></ErrorMessage>
                  <ErrorMessage class="error-post_number_search-message_custom"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.address.isShow">
                <TableTh :isError="false">
                  住所
                  <RequiredText v-show="editUserInputFildes.address.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="24">
                      <el-input
                        :id="editUserInputFildes.address.address1.key"
                        :name="editUserInputFildes.address.address1.key"
                        :placeholder="editUserInputFildes.address.address1.placeholder"
                        v-model="form.street_address1"
                        data-validator-name="street_address1_require"
                        @input="handleStreetInput()"
                      />
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="flex-wrap u-mr--10">
                    <el-col :span="24">
                      <el-input
                        :name="editUserInputFildes.address.address2.key"
                        :placeholder="editUserInputFildes.address.address2.placeholder"
                        v-model="form.street_address2"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-street_address1-required"></ErrorMessage>
                  <ErrorMessage class="error-street_address1-maxlen"></ErrorMessage>
                  <ErrorMessage class="error-street_address1-string"></ErrorMessage>
                  <ErrorMessage class="error-street_address1-address"></ErrorMessage>
                  <ErrorMessage class="error-street_address2-maxlen"></ErrorMessage>
                  <ErrorMessage class="error-street_address2-string"></ErrorMessage>
                  <FormAttention>「丁目」や「番地」の登録など、今一度ご登録内容のご確認をお願いします。</FormAttention>
                  <FormAttention>部屋番号の前にマンション、アパート名のご登録をお願いします。</FormAttention>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.addressKana.isShow">
                <TableTh :isError="false">
                  住所カナ
                  <RequiredText v-show="editUserInputFildes.addressKana.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="24">
                      <el-input
                        :id="editUserInputFildes.addressKana.key"
                        :name="editUserInputFildes.addressKana.key"
                        :placeholder="editUserInputFildes.addressKana.placeholder"
                        v-model="form.street_address_kana"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-street_address_kana-address_kana"></ErrorMessage>
                  <ErrorMessage class="error-street_address_kana-string"></ErrorMessage>
                  <ErrorMessage class="error-street_address_kana-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.tel.isShow">
                <TableTh :isError="false">
                  自宅TEL
                  <RequiredText v-show="editUserInputFildes.tel.required" />
                </TableTh>
                <td>
                  <PhoneNumberInput
                    phoneName1="fixed_phone1"
                    phoneName2="fixed_phone2"
                    phoneName3="fixed_phone3"
                    :phoneModelVal1.sync="form.fixed_phone1"
                    :phoneModelVal2.sync="form.fixed_phone2"
                    :phoneModelVal3.sync="form.fixed_phone3"
                  />
                  <ErrorMessage class="error-fixed_phone-integer"></ErrorMessage>
                  <ErrorMessage class="error-fixed_phone-string"></ErrorMessage>
                  <ErrorMessage class="error-fixed_phone-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.mobile.isShow">
                <TableTh :isError="false">
                  携帯TEL
                  <RequiredText v-show="editUserInputFildes.mobile.required" />
                </TableTh>
                <td>
                  <PhoneNumberInput
                    phoneName1="mobile_phone1"
                    phoneName2="mobile_phone2"
                    phoneName3="mobile_phone3"
                    :phoneModelVal1.sync="form.mobile_phone1"
                    :phoneModelVal2.sync="form.mobile_phone2"
                    :phoneModelVal3.sync="form.mobile_phone3"
                    phoneNameValidationName1="mobile_phone1_require"
                    phoneNameValidationName2="mobile_phone2_require"
                    phoneNameValidationName3="mobile_phone3_require"
                    :disabled="true"
                  />
                  <ErrorMessage class="error-mobile_phone-required"></ErrorMessage>
                  <ErrorMessage class="error-mobile_phone-integer"></ErrorMessage>
                  <ErrorMessage class="error-mobile_phone-string"></ErrorMessage>
                  <ErrorMessage class="error-mobile_phone-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.familyAbout.isShow">
                <TableTh :isError="false">
                  ご家族について
                  <RequiredText v-show="editUserInputFildes.familyAbout.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="10" class="u-w--200">
                      <el-select :name="editUserInputFildes.familyAbout.key" v-model="form.family_about">
                        <el-option
                          v-for="(item, index) in editUserInputFildes.familyAbout.choices"
                          :key="index"
                          :value="item.value"
                          :label="item.label"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col class="text-right" :span="3">&nbsp;同居人数</el-col>
                    <el-col :span="3" class="u-w--90">
                      <el-input
                        type="tel"
                        :name="editUserInputFildes.familyAboutNumber.key"
                        v-model="form.family_about_number"
                        maxlength="2"
                        class="text-right"
                      />
                    </el-col>
                    <el-col :span="2">&nbsp;人</el-col>
                  </el-row>
                  <FormNotice> 結婚されてる方は「配偶者有」を選択してください。</FormNotice>
                  <ErrorMessage class="error-family_about-required"></ErrorMessage>
                  <ErrorMessage class="error-family_about_number-required"></ErrorMessage>
                  <ErrorMessage class="error-family_about_number-integer"></ErrorMessage>
                  <ErrorMessage class="error-family_about_number-maxlen"></ErrorMessage>
                  <ErrorMessage class="error-family_about_number-limit"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.familyStructure.isShow">
                <TableTh :isError="false">
                  世帯人数{{ form.has_payment === 'credit' ? '（同一生計人数）' : '' }}
                  <RequiredText v-show="editUserInputFildes.familyStructure.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="3" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.familyStructure.key"
                        v-model="form.family_structure"
                        @change="onChangeFamilyStructure"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.familyStructure.choices"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <FormNotice
                    >同居・別居に係らず、同一生計で生活しているご家族の人数をご入力ください。（申込者ご本人も含みます）</FormNotice
                  >
                  <ErrorMessage class="error-family_structure-required"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.residenceClassification.isShow">
                <TableTh :isError="false">
                  ご住居
                  <RequiredText v-show="editUserInputFildes.residenceClassification.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="7" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.residenceClassification.key"
                        v-model="form.residence_classification"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.residenceClassification.choices"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-residence_classification-required"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.residencePeriod.isShow">
                <TableTh :isError="false">
                  居住年数
                  <RequiredText v-show="editUserInputFildes.residencePeriod.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <div class="d-flex align-items-center flex-shrink-0 mr-2">
                      <el-col :span="3" class="u-w--200 flex-shrink-0">
                        <el-select
                          :name="editUserInputFildes.residencePeriod.year.key"
                          v-model="form.residence_period_year"
                        >
                          <el-option
                            v-for="(item, key) in editUserInputFildes.residencePeriod.year.choices"
                            :key="key"
                            :value="item.value"
                            :label="item.label"
                          />
                        </el-select>
                      </el-col>
                    </div>
                  </el-row>
                  <ErrorMessage class="error-residence_period_year-required"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.loanRent.isShow">
                <TableTh :isError="false">
                  申込者又はその配偶者の<br>住宅ローン・家賃のお支払い
                  <RequiredText v-show="editUserInputFildes.loanRent.required" />
                </TableTh>
                <td>
                  <el-row>
                    <InputRadio
                      name="loan_rent"
                      :choices="editUserInputFildes.loanRent.choices"
                      :inputRadioVal.sync="form.loan_rent"
                      :handleChange="
                        ($event) => {
                          onChangeLoanRent()
                        }
                      "
                    />
                    <!-- <el-radio v-for="(item, key) in editUserInputFildes.loanRent.choices" :label="item.value" :key="key" name="loan_rent" v-model="form.loan_rent"
                                    >
                                        {{item.value}}
                                    </el-radio> -->
                  </el-row>
                  <ErrorMessage class="error-loan_rent-required"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>

        <SegmentName v-show="editUserInputFildes.householderRelationOptions.isShow">世帯主について</SegmentName>
        <div class="table_block" v-show="editUserInputFildes.householderRelationOptions.isShow">
          <table>
            <tbody>
              <TableTr>
                <TableTh :isError="false">
                  お申込者と世帯主の関係
                  <RequiredText v-show="editUserInputFildes.householderRelationOptions.householderRelation.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="6" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.householderRelationOptions.householderRelation.key"
                        v-model="form.householder_relation"
                        :disabled="form.family_structure === 1"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.householderRelationOptions.householderRelation
                            .choices"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <FormNotice>お申込者ご自身と世帯主の方との関係についてご選択ください</FormNotice>
                  <FormNotice>ご自身が世帯主の場合は「本人」をご選択ください</FormNotice>
                  <FormNotice>配偶者が世帯主の場合は「配偶者」をご選択ください</FormNotice>
                  <FormNotice>※「世帯主」とは、その世帯の主たる生計維持者のことを言います</FormNotice>
                  <FormNotice>※ {{ form.has_payment === 'credit' ? '生計人数' : '世帯人数' }}が1人の場合は世帯主は本人となります</FormNotice>
                  <ErrorMessage class="error-householder_relation-required"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.householderIncome.isShow">
                <TableTh :isError="false">
                  世帯主の税込年収
                  <RequiredText v-show="editUserInputFildes.householderIncome.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="4" class="u-w--90">
                      <el-input
                        :name="editUserInputFildes.householderIncome.key"
                        placeholder=""
                        v-model="form.householder_income"
                        data-validator-name="householder_income_require"
                        type="tel"
                        @blur="isComma('householder_income')"
                        @focus="noneComma('householder_income')"
                        class="text-right"
                        maxlength="5"
                      />
                    </el-col>
                    <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
                  </el-row>
                  <FormNotice v-show="form.householder_relation === '配偶者'">世帯主・配偶者等の生計を一にする方本人の申告に基づき、ご入力ください。</FormNotice>
                  <ErrorMessage class="error-householder_income-required_if"></ErrorMessage>
                  <ErrorMessage class="error-householder_income-integer"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.householderIncomeType.isShow">
                <TableTh :isError="false">
                  世帯主の所得種類
                  <RequiredText v-show="editUserInputFildes.householderIncomeType.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="6" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.householderIncomeType.key"
                        v-model="form.householder_income_type"
                        @change="handleChangeHouseholderIncomeType($event)"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.householderIncomeType.choices"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="8" class="u-w--240">
                      <el-input
                        :name="editUserInputFildes.householderIncomeTypeOtherName.key"
                        placeholder=""
                        v-model="form.householder_income_type_other_name"
                        :disabled="form.householder_income_type !== 'その他'"
                        data-validator-name="householder_income_type_other_name_require"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-householder_income_type-required_if"></ErrorMessage>
                  <ErrorMessage class="error-householder_income_type_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-householder_income_type_other_name-string"></ErrorMessage>
                  <ErrorMessage class="error-householder_income_type_other_name-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.householderMonthlyCreditPayments.isShow">
                <TableTh :isError="false">
                  世帯主の<br />クレジット月間支払額
                  <RequiredText v-show="editUserInputFildes.householderMonthlyCreditPayments.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="3" class="u-w--90 flex-shrink-0">
                      <el-input
                        :name="editUserInputFildes.householderMonthlyCreditPayments.key"
                        placeholder=""
                        v-model="form.householder_monthly_credit_payments"
                        data-validator-name="householder_monthly_credit_payments_require"
                        type="tel"
                        @blur="isComma('householder_monthly_credit_payments')"
                        @focus="noneComma('householder_monthly_credit_payments')"
                        class="text-right"
                        maxlength="5"
                      />
                    </el-col>
                    <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
                  </el-row>
                  <ErrorMessage class="error-householder_monthly_credit_payments-required_if"></ErrorMessage>
                  <ErrorMessage class="error-householder_monthly_credit_payments-integer"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>

        <SegmentName>顧客情報の変更・実家(緊急連絡先)情報</SegmentName>
        <div class="table_block">
          <table>
            <tbody>
              <TableTr v-show="editUserInputFildes.parentHouseOptions.isShow">
                <TableTh :isError="false">
                  郵便番号
                  <RequiredText v-show="editUserInputFildes.parentHouseOptions.parentsPost.required" />
                </TableTh>
                <td>
                  <el-checkbox 
                    @change="handleAddressCopy" 
                    v-model="parents_address_copy_flg" 
                    :checked="getInitialCheck"
                  >
                    現住所と同じ
                  </el-checkbox>
                  <ZipcodeSearch
                    name="parents_post"
                    dataValidationName="parents_post_require"
                    :zipcodeVal.sync="form.parents_post"
                    :handleBlur="
                      ($event) => {
                        arrangeAddHyphen($event, 'parents_post')
                      }
                    "
                    :handleClickSearch="onClickSearchParentPostNumber"
                  />
                  <FormNotice>例)100-0000</FormNotice>
                  <FormNotice
                    >例)100-0000 郵便番号がわからない場合は<a
                      href="https://www.post.japanpost.jp/zipcode/"
                      target="_blank"
                      >こちら</a
                    ></FormNotice
                  >
                  <FormAttention>申込者ご本人以外のご連絡先のご登録をお願いします。</FormAttention>
                  <ErrorMessage class="error-parents_post-required"></ErrorMessage>
                  <ErrorMessage class="error-parents_post-post"></ErrorMessage>
                  <ErrorMessage class="error-parents_post_search-message_custom"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.parentHouseOptions.isShow">
                <TableTh :isError="false">
                  住所
                  <RequiredText v-show="editUserInputFildes.parentHouseOptions.parentsAddress.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-input
                        name="parents_address"
                        :placeholder="editUserInputFildes.parentHouseOptions.parentsAddress.address.placeholder"
                        v-model="form.parents_address"
                        data-validator-name="parents_address_require"
                      />
                    </el-col>
                  </el-row>
                  <FormAttention>「丁目」や「番地」の登録など、今一度ご登録内容のご確認をお願いします。</FormAttention>
                  <FormAttention>部屋番号の前にマンション、アパート名のご登録をお願いします。</FormAttention>
                  <ErrorMessage class="error-parents_address-required"></ErrorMessage>
                  <ErrorMessage class="error-parents_address-address"></ErrorMessage>
                  <ErrorMessage class="error-parents_address-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.parentHouseOptions.isShow">
                <TableTh :isError="false">
                  TEL
                  <RequiredText v-show="editUserInputFildes.parentHouseOptions.phone.required" />
                </TableTh>
                <td>
                  <el-checkbox v-model="form.parents_phone_exists" @change="onToggleParentsPhone">
                    固定電話
                  </el-checkbox>
                  <PhoneNumberInput
                    v-show="form.parents_phone_exists"
                    phoneName1="parents_phone1"
                    phoneName2="parents_phone2"
                    phoneName3="parents_phone3"
                    :phoneModelVal1.sync="form.parents_phone1"
                    :phoneModelVal2.sync="form.parents_phone2"
                    :phoneModelVal3.sync="form.parents_phone3"
                    phoneNameValidationName1="parents_phone1_require_if"
                    phoneNameValidationName2="parents_phone2_require_if"
                    phoneNameValidationName3="parents_phone3_require_if"
                    :phoneBlur1="parentsPhoneValidate"
                    :phoneBlur2="parentsPhoneValidate"
                    :phoneBlur3="parentsPhoneValidate"
                  />
                  <div class="fx mg_tb_10">
                    <el-checkbox v-model="form.parents_mobile_exists" @change="onToggleParentsMobile">
                      携帯電話
                    </el-checkbox>
                    <div class="fx" v-show="form.parents_mobile_exists">
                      <span>(続柄:</span>
                        <el-col :span="6" class="u-w--200">
                          <el-select
                            :name="'parents_phone_relationship'"
                            v-model="form.parents_phone_relationship"
                            @blur="parentsPhoneValidate"
                            @change="handleChangeParentsPhoneRelationship($event)"
                          >
                            <el-option
                              v-for="(item, key) in editUserInputFildes.parentHouseOptions.phone.relationShip.choices"
                              :key="key"
                              :value="item.value"
                              :label="item.label"
                            />
                          </el-select>
                        </el-col> 
                      <span>)</span>
                      <el-col :span="8" class="u-w--240">
                        <el-input
                          :name="editUserInputFildes.parentHouseOptions.phone.relationShipOtherName.key"
                          placeholder=""
                          v-model="form.parents_phone_relationship_other_name"
                          maxlength="10"
                          :disabled="form.parents_phone_relationship !== 'その他'"
                          @blur="parentsPhoneValidate"
                        />
                      </el-col>
                    </div>
                  </div>
                  <PhoneNumberInput
                    v-show="form.parents_mobile_exists"
                    phoneName1="parents_mobile_phone1"
                    phoneName2="parents_mobile_phone2"
                    phoneName3="parents_mobile_phone3"
                    :phoneModelVal1.sync="form.parents_mobile_phone1"
                    :phoneModelVal2.sync="form.parents_mobile_phone2"
                    :phoneModelVal3.sync="form.parents_mobile_phone3"
                    phoneNameValidationName1="parents_mobile_phone1_require"
                    phoneNameValidationName2="parents_mobile_phone2_require"
                    phoneNameValidationName3="parents_mobile_phone3_require"
                    :phoneBlur1="parentsPhoneValidate"
                    :phoneBlur2="parentsPhoneValidate"
                    :phoneBlur3="parentsPhoneValidate"
                  />
                  <ErrorMessage class="error-parents_phone-integer"></ErrorMessage>
                  <ErrorMessage class="error-parents_phone-required"></ErrorMessage>
                  <ErrorMessage class="error-parents_phone_relationship-required"></ErrorMessage>
                  <ErrorMessage class="error-parents_phone_relationship_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-parents_mobile_phone-integer"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>

        <SegmentName>顧客情報の変更・卒業予定・お勤め先・収入</SegmentName>
        <div class="table_block">
          <table>
            <tbody>
              <TableTr v-show="editUserInputFildes.occupation.isShow">
                <TableTh :isError="false">
                  お勤め先・学校について
                  <RequiredText v-show="editUserInputFildes.occupation.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="6" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.occupation.key"
                        v-model="form.occupation"
                        @change="onChangeOccupation"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.occupation.choices"
                          :key="key"
                          :value="item.value"
                          :label="item.value"
                          :disabled="item.value === '無職'"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="8" class="u-w--240">
                      <el-input
                        :name="editUserInputFildes.occupationOtherName.key"
                        placeholder=""
                        v-model="form.occupation_other_name"
                        :disabled="form.occupation !== 'その他'"
                        data-validator-name="occupation_other_name_require"
                      />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-checkbox name="student_unemployed_flg" 
                      v-show="editUserInputFildes.studentUnemployedFlg.isShow" 
                      v-model="form.student_unemployed_flg"
                      :checked="getInitialUnemployedCheck"
                    >
                      <span class="unemplyed_flg">アルバイトをされていない方はチェックを入れて下さい。</span>
                    </el-checkbox>
                  </el-row>
                  <ErrorMessage class="error-occupation-required"></ErrorMessage>
                  <ErrorMessage class="error-occupation_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-occupation_other_name-string"></ErrorMessage>
                  <ErrorMessage class="error-occupation_other_name-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.expectedGraduation.isShow">
                <TableTh :isError="false">
                  卒業予定
                  <RequiredText v-show="editUserInputFildes.expectedGraduation.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col class="u-w--auto">西暦&nbsp;</el-col>
                    <el-col :span="5" class="u-w--150">
                      <el-select
                        :name="editUserInputFildes.expectedGraduation.year.key"
                        placeholder=""
                        v-model="form.graduate_year"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.GranduateYear(form.application_date_year)"
                          :key="key"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="3" class="u-w--120">
                      <el-select
                        :name="editUserInputFildes.expectedGraduation.month.key"
                        placeholder=""
                        v-model="form.graduate_month"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.Months"
                          :key="key"
                          :label="`${item.value}月`"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-graduate_year-required_if"></ErrorMessage>
                  <ErrorMessage class="error-graduate_month-required_if"></ErrorMessage>
                  <ErrorMessage class="error-graduate-required_if"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyName.isShow">
                <TableTh :isError="false">
                  お勤め先名称
                  <RequiredText v-show="editUserInputFildes.companyName.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="24">
                      <el-input
                        :name="editUserInputFildes.companyName.key"
                        placeholder=""
                        v-model="form.company_name"
                        data-validator-name="company_name_require"
                        :id="editUserInputFildes.companyName.key"
                        @input="handleCompanuyNameInput()"
                      />
                    </el-col>
                  </el-row>
                  <FormNotice v-show="form.occupation === '学生（アルバイト）'">アルバイト先を必ず入力してください(通学先の学校名は不可)</FormNotice>
                  <ErrorMessage class="error-company_name-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-company_name-string"></ErrorMessage>
                  <ErrorMessage class="error-company_name-maxlen"></ErrorMessage
                  ><!-- maxlen:40 -->
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyNameKana.isShow">
                <TableTh :isError="false">
                  お勤め先名称 フリガナ
                  <RequiredText v-show="editUserInputFildes.companyNameKana.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle">
                    <el-col :span="24">
                      <el-input
                        :name="editUserInputFildes.companyNameKana.key"
                        placeholder=""
                        v-model="form.company_name_kana"
                        data-validator-name="company_name_kana_require"
                        :id="editUserInputFildes.companyNameKana.key"
                      />
                    </el-col>
                  </el-row>
                  <FormNotice>必ず全角カタカナで入力してください</FormNotice>
                  <ErrorMessage class="error-company_name_kana-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_name_kana-required_if"></ErrorMessage>
                  <ErrorMessage class="error-company_name_kana-company_kana"></ErrorMessage>
                  <ErrorMessage class="error-company_name_kana-string"></ErrorMessage>
                  <ErrorMessage class="error-company_name_kana-maxlen"></ErrorMessage
                  ><!-- maxlen:40 -->
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyPhone.isShow">
                <TableTh :isError="false">
                  お勤め先TEL
                  <RequiredText v-show="editUserInputFildes.companyPhone.required" />
                </TableTh>
                <td>
                  <PhoneNumberInput
                    phoneName1="company_phone1"
                    phoneName2="company_phone2"
                    phoneName3="company_phone3"
                    :phoneModelVal1.sync="form.company_phone1"
                    :phoneModelVal2.sync="form.company_phone2"
                    :phoneModelVal3.sync="form.company_phone3"
                    phoneNameValidationName1="company_phone1_require"
                    phoneNameValidationName2="company_phone2_require"
                    phoneNameValidationName3="company_phone3_require"
                  />
                  <ErrorMessage class="error-company_phone-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_phone-required_if"></ErrorMessage>
                  <ErrorMessage class="error-company_phone-integer"></ErrorMessage>
                  <ErrorMessage class="error-company_phone-string"></ErrorMessage>
                  <ErrorMessage class="error-company_phone-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyJobDescription.isShow">
                <TableTh :isError="false">
                  仕事内容
                  <RequiredText v-show="editUserInputFildes.companyJobDescription.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="7" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.companyJobDescription.key"
                        v-model="form.company_job_description"
                        @change="onChangeJobDescription($event)"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputFildes.companyJobDescription.choices"
                          :key="key"
                          :value="item.value"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="8" class="u-w--240">
                      <el-input
                        :name="editUserInputFildes.companyJobDescriptionOtherName.key"
                        placeholder=""
                        v-model="form.company_job_description_other_name"
                        :disabled="form.company_job_description !== 'その他'"
                        data-validator-name="company_job_description_other_name_require"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-company_job_description-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_job_description_required_if"></ErrorMessage>
                  <ErrorMessage class="error-company_job_description_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-company_job_description_other_name-string"></ErrorMessage>
                  <ErrorMessage class="error-company_job_description_other_name-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.jobDepartment.isShow">
                <TableTh :isError="false">
                  所属部課
                  <RequiredText v-show="editUserInputFildes.jobDepartment.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="24">
                      <el-input
                        :name="editUserInputFildes.jobDepartment.key"
                        placeholder=""
                        v-model="form.job_department"
                        data-validator-name="job_department_require"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-job_department-string"></ErrorMessage>
                  <ErrorMessage class="error-job_department-maxlen"></ErrorMessage
                  ><!-- maxlen:40 -->
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.dispatchedAgent.isShow">
                <TableTh :isError="false">
                  出向派遣元
                  <RequiredText v-show="editUserInputFildes.dispatchedAgent.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle">
                    <el-col :span="24">
                      <el-input
                        :name="editUserInputFildes.dispatchedAgent.key"
                        placeholder=""
                        v-model="form.dispatched_agent"
                        data-validator-name="dispatched_agent_require"
                      />
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-dispatched_agent-string"></ErrorMessage>
                  <ErrorMessage class="error-dispatched_agent-maxlen"></ErrorMessage
                  ><!-- maxlen:40 -->
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyPost.isShow">
                <TableTh :isError="false">
                  お勤め先郵便番号
                  <RequiredText v-show="editUserInputFildes.companyPost.required" />
                </TableTh>
                <td>
                  <ZipcodeSearch
                    name="company_post"
                    dataValidationName="company_post_require"
                    :zipcodeVal.sync="form.company_post"
                    :handleBlur="
                      ($event) => {
                        arrangeAddHyphen($event, 'company_post')
                      }
                    "
                    :handleClickSearch="onClickSearchCompanyPostNumber"
                  />
                  <FormNotice
                    >例)100-0000 郵便番号がわからない場合は<a
                      href="https://www.post.japanpost.jp/zipcode/"
                      target="_blank"
                      >こちら</a
                    ></FormNotice
                  >
                  <ErrorMessage class="error-company_post-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_post-post"></ErrorMessage>
                  <ErrorMessage class="error-company_post_search-message_custom"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyAddress.isShow">
                <TableTh :isError="false">
                  お勤め先住所
                  <RequiredText v-show="editUserInputFildes.companyAddress.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="24">
                      <el-input
                        name="company_address"
                        :placeholder="editUserInputFildes.companyAddress.address.placeholder"
                        v-model="form.company_address"
                        data-validator-name="company_address_require"
                      />
                    </el-col>
                  </el-row>
                  <FormAttention>「丁目」や「番地」の登録など、今一度ご登録内容のご確認をお願いします。</FormAttention>
                  <FormAttention>部屋番号の前にマンション、アパート名のご登録をお願いします。</FormAttention>
                  <ErrorMessage class="error-company_address-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_address-address"></ErrorMessage>
                  <ErrorMessage class="error-company_address-maxlen"></ErrorMessage
                  ><!-- maxlen:40 -->
                  <ErrorMessage class="error-company_address-string"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.joinDate.isShow">
                <TableTh :isError="false">
                  入社年月
                  <RequiredText v-show="editUserInputFildes.joinDate.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="6" class="u-w--200">
                      <el-select
                        :name="editUserInputFildes.joinDate.year.key"
                        placeholder=""
                        v-model="form.join_year"
                        @input="onChangeJoinDate($event)"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.JoinYears()"
                          :key="key"
                          :value="parseInt(item.value)"
                          :label="item.label"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="3" class="u-w--90">
                      <el-select
                        :name="editUserInputFildes.joinDate.month.key"
                        placeholder=""
                        v-model="form.join_month"
                        @input="onChangeJoinDate($event)"
                      >
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.Months"
                          :key="key"
                          :label="`${item.value}月`"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-join_year-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-join_month-required_unless"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.payday.isShow">
                <TableTh :isError="false">
                  給料日
                  <RequiredText v-show="editUserInputFildes.payday.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="3" class="u-w--120">
                      <el-select :name="editUserInputFildes.payday.key" placeholder="" v-model="form.payday">
                        <el-option
                          v-for="(item, key) in editUserInputOptionConstants.PayDay()"
                          :key="key"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-payday-required_unless"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.companyIncome.isShow">
                <TableTh :isError="false">
                  税込年収
                  <RequiredText v-show="editUserInputFildes.companyIncome.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <el-col :span="3" class="u-w--90 flex-shrink-0">
                      <el-input
                        :name="editUserInputFildes.companyIncome.key"
                        placeholder=""
                        v-model="form.company_income"
                        data-validator-name="company_income_require"
                        type="tel"
                        @blur="isComma('company_income')"
                        @focus="noneComma('company_income')"
                        class="text-right"
                        maxlength="5"
                      />
                    </el-col>
                    <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
                  </el-row>
                  <ErrorMessage class="error-company_income-required_unless"></ErrorMessage>
                  <ErrorMessage class="error-company_income-required_if"></ErrorMessage>
                  <ErrorMessage class="error-company_income-integer"></ErrorMessage>
                  <ErrorMessage class="error-company_income-more"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editUserInputFildes.sidelineType.isShow">
                <TableTh :isError="false">
                  その他収入(年額)
                  <RequiredText v-show="editUserInputFildes.sidelineType.required" />
                </TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap u-mr--10">
                    <div class="d-flex flex-wrap align-items-center">
                      <el-col :span="6" class="u-w--200 flex-shrink-0">
                        <el-select
                          :name="editUserInputFildes.sidelineType.key"
                          v-model="form.sideline_type"
                          @change="onChangeSidelineType($event)"
                          clearable
                        >
                          <el-option
                            v-for="(item, key) in editUserInputFildes.sidelineType.choices"
                            :key="key"
                            :value="item.value"
                            :label="item.label"
                          />
                        </el-select>
                      </el-col>
                      <el-col :span="8" class="u-w--240 flex-shrink-0">
                        <el-input
                          :name="editUserInputFildes.sidelineOtherName.key"
                          placeholder=""
                          v-model="form.sideline_other_name"
                          :disabled="form.sideline_type !== 'その他'"
                          data-validator-name="sideline_other_name_require"
                          type="text"
                        />
                      </el-col>
                    </div>
                    <div class="d-flex flex-wrap flex-shrink-0 align-items-center">
                      <el-col :span="3" class="u-w--120 flex-shrink-0">
                        <el-input
                          :name="editUserInputFildes.sidelineIncome.key"
                          placeholder=""
                          v-model="form.sideline_income"
                          @blur="isComma('sideline_income')"
                          @focus="noneComma('sideline_income')"
                          class="text-right"
                          type="tel"
                          maxlength="5"
                        />
                      </el-col>
                      <el-col class="u-w--auto">&nbsp;単位（万円）</el-col>
                    </div>
                  </el-row>
                  <FormNotice>奨学金は収入に含みません。</FormNotice>
                  <ErrorMessage class="error-sideline_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-sideline_other_name-string"></ErrorMessage>
                  <ErrorMessage class="error-sideline_other_name-maxlen"></ErrorMessage
                  ><!-- maxlen:50 -->
                  <ErrorMessage class="error-sideline_income-integer"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>
        <div style="padding-bottom: 15px">
          <el-button type="primary" @click="customerUpdate" v-bind:disabled="isUpdateBtnPushed"
            >変更を保存する</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import {helperSmoothScroll} from '@/js/util/helper'
import * as AutoKana from '@/js/util/ActbeAutokana'
import {EditUserInputFildes} from '@/js/util/admin/editUserInputFildes'
import * as EditUserInputOptionConstants from '@/js/util/admin/editUserInputOptionConstants'
import {
  ValidationRulesFun,
  ValidationRulesCommon,
  ValidationRulesCredit,
  ValidationRulesInstallment,
  ValidationRulesAddCredit,
  ValidationRulesAddInstallment
} from '@/js/util/admin/editUserInputValidationRules'
import {validate, setErrorLaravel} from '@/js/util/validate/validateFunction'
import {eidtUserInputDataTransformWebApi} from '@/js/util/admin/editUserInputDataTransform'

import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
import FormAttention from '@/js/components/member/common/Atoms/FormAttention'
import FormLabel from '@/js/components/member/common/Atoms/FormLabel'
import FormNotice from '@/js/components/member/common/Atoms/FormNotice'
import RequiredText from '@/js/components/member/common/Atoms/RequiredText'
import SegmentName from '@/js/components/member/common/Atoms/SegmentName'
import TableTh from '@/js/components/member/common/Molecules/TableTh'
import TableTr from '@/js/components/member/common/Molecules/TableTr'
import PhoneNumberInput from '@/js/components/member/common/Molecules/PhoneNumberInput'
import ZipcodeSearch from '@/js/components/member/common/Molecules/ZipcodeSearch'
import InputRadio from '@/js/components/member/common/Molecules/InputRadio'
import {Loading} from 'element-ui'

// Auto Kana変数定義
let auto_surname_kana
let auto_first_name_kana
let auto_oldsurname_kana
let auto_street_address_kana
let auto_company_name_kana

export default {
  components: {
    ErrorMessage,
    FormAttention,
    FormLabel,
    FormNotice,
    RequiredText,
    SegmentName,
    TableTh,
    TableTr,
    PhoneNumberInput,
    ZipcodeSearch,
    InputRadio
  },
  data() {
    return {
      contract: {},
      editUserInputFildes: {},
      editUserInputOptionConstants: EditUserInputOptionConstants,
      parents_address_copy_flg: false,  // 現住所と実家の同一フラグ
      form: {
        application_date_year: null, // 申込日(年) ※デフォルトで本日の日付
        application_date_month: null, // 申込日(月) ※デフォルトで本日の日付
        application_date_day: null, // 申込日(日) ※デフォルトで本日の日付
        purpose_of_transaction: '生計費決済', // 取引を行う目的 ※デフォルトで「1:生計費決済」
        purpose_of_transaction_other_name: null, // 取引を行う目(その他）
        is_foreign_government: 'いいえ',
        foreign_government_company: null,
        surname: null, // 姓
        first_name: null, // 名
        old_surname: null, // 旧姓
        surname_kana: null, // 姓(フリガナ)
        first_name_kana: null, // 名(フリガナ)
        old_surname_kana: null, // 旧姓(フリガナ)
        sex_type: 2, // 性別 ※デフォルトで「2:女性」
        birthday_year: null, // 生年月日(年)
        birthday_month: null, // 生年月日(月)
        birthday_day: null, // 生年月日(日)
        post_number: null, // 郵便番号
        street_address1: null, // 住所1
        street_address2: null, // 住所2
        street_address_kana: null, // 住所カナ(住所1のカナ)
        fixed_phone1: null, // 固定電話
        fixed_phone2: null, // 固定電話
        fixed_phone3: null, // 固定電話
        mobile_phone1: null, // 携帯電話
        mobile_phone2: null, // 携帯電話
        mobile_phone3: null, // 携帯電話
        family_about: null, // ご家族について
        family_about_number: null, // ご家族についての同居人数
        family_structure: null, // 生計同一人数
        residence_classification: null, // 住居形態
        residence_period_year: null, // 居住年数(年)
        loan_rent: null, // ローン有無
        householder_relation: '本人', // 世帯主との関係 ※デフォルトは「本人」
        householder_income: null, // 世帯主収入
        householder_income_type: null, // 世帯主の所得種類
        householder_income_type_other_name: null, // 世帯主の所得種類 その他の場合のテキスト
        householder_monthly_credit_payments: null, // 世帯主のクレジット月間支払い額
        parents_post: null, // 実家郵便番号
        parents_address: null, // 実家住所
        parents_phone1: null, // 実家固定電話番号
        parents_phone2: null, // 実家固定電話番号
        parents_phone3: null, // 実家固定電話番号
        parents_phone_exists: false,  // 実家固定電話の入力有無
        parents_mobile_phone1: null, // 実家携帯電話番号
        parents_mobile_phone2: null, // 実家携帯電話番号
        parents_mobile_phone3: null, // 実家携帯電話番号
        parents_mobile_exists: false,  // 実家携帯電話の入力有無
        parents_phone_relationship: null,  // 実家携帯電話の続柄
        parents_phone_relationship_other_name: null, // 実家携帯電話の続柄(その他)
        occupation: null, // お勤め先・学校について
        occupation_other_name: null, // お勤め先・学校について　その他の場合のテキスト
        student_unemployed_flg: false, // （※自社割賦限定）「アルバイトをされていない方はチェックを入れて下さい。」のチェック
        graduate_year: null, // 卒業予定(年)
        graduate_month: null, // 卒業予定(月)
        company_name: null, // お勤め先
        company_name_kana: null, // お勤め先カナ
        company_phone1: null, // お勤め先電話番号
        company_phone2: null, // お勤め先電話番号
        company_phone3: null, // お勤め先電話番号
        company_job_description: null, // 仕事内容
        company_job_description_other_name: null, // 仕事内容 その他の場合のテキスト
        job_department: null, // 所属部課
        dispatched_agent: null, // 出向派遣元
        company_post: null, // 勤め先郵便番号
        company_address: null, // 勤め先住所
        join_year: null, // 入社年月(年)
        join_month: null, // 入社年月(月)
        payday: null, // 給料日
        company_income: null, // 税込年収
        sideline_type: null, // その他収入
        sideline_other_name: null, // その他収入 その他の場合のテキスト
        sideline_income: null, // その他収入(年額)
        comapny_employees_number: null, // 勤め先社員数
        bank_deposit: null, // 預金額
        spouse_income: null, // 配偶者の年収
        is_change_customer: null, // 変更届フラグ
        has_payment: 'credit'
      },
      birthdayDays: [],
      applicationDays: [],
      isUpdateBtnPushed: false,
      has_payment: 'credit',
      type: 'new'
    }
  },
  computed: {
    /**
     * 実家(緊急連絡先)情報欄の「現住所と同じ」チェックボックス初期値
     */
    getInitialCheck() {
      return this.form.street_address1 === this.form.parents_address || (this.form.street_address1 ?? '') + (this.form.street_address2 ?? '') === this.form.parents_address
    },
    getInitialUnemployedCheck() {
      return this.form.student_unemployed_flg
    }
  },
  created() {},
  async mounted() {
    this.contract = await this.getContract()

    this.has_payment = this.contract.has_payment
    this.type = this.contract.type.toLowerCase()

    this.editUserInputFildes = EditUserInputFildes(this.has_payment, this.form, this.type)

    const form_list = eidtUserInputDataTransformWebApi(this.contract, this.contract.customer)
    this.form = this.valueConversion(EditUserInputOptionConstants.Conversions, true, form_list)
    this.form.has_payment = this.has_payment
    this.form.type = this.type
    this.form.is_change_customer = this.contract.is_change_customer

    setTimeout(() => {
      // Auto Kanaの設定
      auto_surname_kana = AutoKana.bind(
        `#${this.editUserInputFildes.name.surname.key}`,
        `#${this.editUserInputFildes.nameKana.surname.key}`,
        {katakana: true}
      )
      auto_first_name_kana = AutoKana.bind(
        `#${this.editUserInputFildes.name.firstName.key}`,
        `#${this.editUserInputFildes.nameKana.firstName.key}`,
        {katakana: true}
      )
      auto_oldsurname_kana = AutoKana.bind(
        `#${this.editUserInputFildes.oldSurname.key}`,
        `#${this.editUserInputFildes.oldSurnameKana.key}`,
        {katakana: true}
      )
      auto_street_address_kana = AutoKana.bind(
        `#${this.editUserInputFildes.address.address1.key}`,
        `#${this.editUserInputFildes.addressKana.key}`,
        {katakana: true}
      )
      auto_company_name_kana = AutoKana.bind(
        `#${this.editUserInputFildes.companyName.key}`,
        `#${this.editUserInputFildes.companyNameKana.key}`,
        {katakana: true}
      )

      // バリデーションを定義
      validate(this.returnValidationRules(), true, this.has_payment)

      // 申込日の日の定義
      this.onChangeApplicationDate()

      // 誕生日の日の定義
      this.onChangeBirthday()
    }, 500)
  },
  beforeDestroy() {
    // バリデーションを削除
    validate(this.returnValidationRules(), false, this.has_payment)
  },
  methods: {
    back() {
      this.$confirm('変更を保存しますか？', '変更確認', {
        confirmButtonText: 'はい',
        cancelButtonText: '詳細画面へ',
        type: 'info'
      })
        .then(() => {
          this.customerUpdate()
        })
        .catch(() => {
          this.transitionSame('list-detail')
        })
    },
    changeWrapMounted() {},
    /**
     * 契約を取得する処理
     */
    getContract() {
      return new Promise((resolve) => {
        axios
          .get(`/api/store/contract/${this.$route.params.id}`)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    customerUpdate() {
      this.isUpdateBtnPushed = true
      const loadingItem = Loading.service({})
      // 学生アルバイトでアルバイトをしていないケースかつ０円で税込み年収が登録されている場合は税込み年収をnullにする
      // 専業主婦、無職かつ０円で税込み年収が登録されている場合は税込み年収をnullにする
      if((this.form.student_unemployed_flg || ['無職', '専業主婦'].includes(this.form.occupation)) && this.form.company_income == 0) {
        this.form.company_income = null
      }
      // バリデーションチェック
      const validationRules = this.returnValidationRules()
      for (let key in validationRules) {
        validationRules[key].map(async (validation) => {
          if (validation.rule.match('message_custom')) document.getElementById(key).value = true
          await this.ignitionEvent(validation.event, key)
        })
      }
      // 実家固定電話・実家携帯電話のバリデーション実行
      this.parentsPhoneValidate()

      setTimeout(() => {
        let errors = document.querySelectorAll('.error_message')
        let error_class = ''
        for (var i = 0; i < errors.length; i++) {
          if (errors[i].innerHTML) {
            error_class = errors[i].className
            break
          }
        }
        if (error_class) {
          helperSmoothScroll(error_class, true)
          this.$message.error('入力に不備があります。入力内容をご確認ください。')
        } else {
          const copy = _.cloneDeep(this.form)
          // 強制的に顧客情報を変更
          axios
            .put(
              '/api/store/customer/' + this.$route.params.id,
              this.valueConversion(EditUserInputOptionConstants.Conversions, false, copy)
            )
            .then((res) => {
              this.$message(`顧客情報　更新完了`)
              this.transitionSame('list-detail')
            })
            .catch((err) => {
              console.log(err, err.response.data)
              if(err.response.status === 422) {
                this.$message.error('入力に不備があります。入力内容をご確認ください。')
              } else {
                this.$message.error('送信に失敗しました。入力内容をご確認ください。')
              }
              if (err.response.data) {
                const error_validations = []
                for (let key in err.response.data) {
                  err.response.data[key].map((item) => {
                    let terms = item.split(':')
                    const obj = {
                      rule: terms[0],
                      message: terms[1],
                      key: key
                    }
                    error_validations.push(obj)
                  })
                }
                error_validations.map((validate) => {
                  setErrorLaravel(validate.key, validate.rule, validate.message, true)
                })
                setTimeout(() => {
                  errors = document.querySelectorAll('.error_message')
                  error_class = ''
                  for (var i = 0; i < errors.length; i++) {
                    if (errors[i].innerHTML) {
                      error_class = errors[i].className
                      break
                    }
                  }
                  if (error_class) {
                    helperSmoothScroll(error_class, true)
                  }
                }, 100)
              }
            })
        }
      }, 500)
      this.isUpdateBtnPushed = false
      loadingItem.close()
    },
    /**
     * バリデーションのルールをレスポンス
     */
    returnValidationRules() {
      let uniqueRule
      if (this.has_payment === 'credit') {
        uniqueRule = this.type != 'new' ? ValidationRulesAddCredit : ValidationRulesCredit
      } else {
        uniqueRule = this.type != 'new' ? ValidationRulesAddInstallment : ValidationRulesInstallment
      }
      return ValidationRulesFun(ValidationRulesCommon, uniqueRule)
    },
    /**
     * 実家固定電話と実家携帯電話のinput属性にバリデーション実行
     */
    parentsPhoneValidate() {
      // 実家TELのErrorMessageタグを初期化
      const reqErrorEl = document.querySelector('.error-parents_phone-required')
      reqErrorEl.innerHTML = ''
      const relationErrorEl = document.querySelector('.error-parents_phone_relationship-required')
      relationErrorEl.innerHTML = ''
      const othernmErrorEl = document.querySelector('.error-parents_phone_relationship_other_name-required_if')
      othernmErrorEl.innerHTML = ''
      
      // 追加申込の場合はバリデーションを実行しない
      if(this.type === 'add') return
      const nocheckMsg = '実家固定電話または実家携帯電話のどちらかを選択してください。'
      const requiredPhoneMsg = '電話番号は必ず入力してください。'
      const requiredRelationshipMsg = '続柄は必ず選択してください。'
      const requiredRelationshipOtherMsg = '実家携帯電話の続柄 (その他)は必ず入力してください。'
      const keyList = [1,2,3]
      let phoneErrorFlg = false
      let mobileErrorFlg = false
      
      // 実家TELのヘッダ
      const header = reqErrorEl.closest('.js_error').querySelector('.js_error_header')
      header.classList.remove(`is_active_parents_phone_required_origin`)
      header.classList.remove('is_active_parents_phone_relationship_other_name_required_if')

      // バリデーションチェック(どちらか一方にチェックが入っていない場合はエラー判定)
      if(!this.form.parents_phone_exists && !this.form.parents_mobile_exists) {
        reqErrorEl.innerHTML = nocheckMsg
        header.classList.add(`is_active_parents_phone_required_origin`)
        return
      }
      // バリデーションチェック(携帯電話の場合は続柄に値が入っていない場合はエラー判定)
      if(this.form.parents_mobile_exists && !this.form.parents_phone_relationship) {
        relationErrorEl.innerHTML = requiredRelationshipMsg
        header.classList.add(`is_active_parents_phone_required_origin`)
      }
      // バリデーションチェック(携帯電話の場合かつ、続柄がその他で値が入っていない場合はエラー判定)
      if (this.form.parents_phone_relationship === 'その他' && !this.form.parents_phone_relationship_other_name) {
        othernmErrorEl.innerHTML = requiredRelationshipOtherMsg
        header.classList.add(`is_active_parents_phone_required_origin`)
        header.classList.add('is_active_parents_phone_relationship_other_name_required_if')
      }
      // バリデーションチェック(固定電話か携帯電話のどちらか一方が値入っていない場合はエラー判定)
      keyList.map(val => {
        if(this.form.parents_phone_exists) {
          const phoneEl = document.getElementsByName(`parents_phone${val}`)
          if(!phoneErrorFlg && !phoneEl[0].value) phoneErrorFlg = true
        }
        if(this.form.parents_mobile_exists) {
          const mobileEl = document.getElementsByName(`parents_mobile_phone${val}`)
          if(!mobileErrorFlg && !mobileEl[0].value) mobileErrorFlg = true
        }
      })
      if((!mobileErrorFlg && phoneErrorFlg) || mobileErrorFlg) {
        reqErrorEl.innerHTML = requiredPhoneMsg
        if(!header.classList.contains(`is_active_parents_phone_required_origin`)) header.classList.add(`is_active_parents_phone_required_origin`)
      }
    },
    // 申込日
    onChangeApplicationDate() {
      const selectedYear = this.form.application_date_year
      const selectedMonth = this.form.application_date_month
      const selectedDay = this.form.application_date_day
      const selectedLastDay = moment()
      selectedLastDay.year(selectedYear)
      selectedLastDay.month(selectedMonth - 1)
      selectedLastDay.endOf('month')
      const selectedMonthLastDate = selectedLastDay.date()

      if (selectedMonthLastDate < selectedDay) {
        this.form.application_date_day = null
      }

      this.applicationDays = [...Array(selectedMonthLastDate).keys()].map((i) => {
        const tmp = i + 1
        return {
          value: `${tmp}`,
          label: `${tmp}日`
        }
      })
    },
    // 取引を行う目的
    onChangepurposeOfTransaction(e) {
      if (e === 'その他') return
      this.form.purpose_of_transaction_other_name = null
      this.ignitionEvent('blur', 'purpose_of_transaction_other_name')
    },
    onChangeIsForeignGovernment(e) {
      if (e === '1') return
      this.form.foreign_government_company = null
      this.ignitionEvent('blur', this.editUserInputFildes.isForeignGovernment.key)
    },
    // 性別
    onChangeSexType() {
      this.ignitionEvent('blur', 'sex_type')
    },
    // 生年月日選択
    onChangeBirthday() {
      const selectedYear = this.form.birthday_year
      const selectedMonth = this.form.birthday_month
      const selectedDay = this.form.birthday_day
      const selectedLastDay = moment()
      selectedLastDay.year(selectedYear)
      selectedLastDay.month(selectedMonth - 1)
      selectedLastDay.endOf('month')
      const selectedMonthLastDate = selectedLastDay.date()

      if (selectedMonthLastDate < selectedDay) {
        this.form.birthday_day = null
      }

      this.birthdayDays = [...Array(selectedMonthLastDate).keys()].map((i) => {
        const tmp = i + 1
        return {
          value: `${tmp}`,
          label: `${tmp}日`
        }
      })
    },
    // 郵便番号検索
    onClickSearchPostNumber() {
      const result = document.getElementById('post_number_search')
      axios
        .get(`/search-address?postcode=${this.form.post_number}`)
        .then((res) => {
          console.log(res.data)
          this.form.street_address1 = res.data.addr1 + res.data.addr2 + res.data.addr3
          this.form.street_address_kana = res.data.kana1 + ' ' + res.data.kana2 + ' ' + res.data.kana3 + ' '
          result.value = true
          this.ignitionEvent('blur', 'post_number_search')
          this.ignitionEvent('input', 'post_number')
          this.ignitionEvent('blur', 'street_address1')
          this.ignitionEvent('input', 'street_address1')
          // this.ignitionEvent('blur','street_address2');
          // this.ignitionEvent('input','street_address2');
          // this.ignitionEvent('input','street_address3');
        })
        .catch((res) => {
          // console.log(result.value)
          result.value = false
          // console.log(result.value)
          this.ignitionEvent('blur', 'post_number_search')
          // this.validationRules.post_number_search.isError = true;
        })
    },
    // ご家族 > 子供
    onChangeChildStatus(e) {
      if (e === '有') return
      // this.validationRules.child_number_require.isError = false;
      this.form.child_number = null
      this.ignitionEvent('blur', 'child_number')
    },
    // ご家族 > その他
    onChangeOthersStatus(e) {
      if (e === '有') return
      // this.validationRules.others_number_require.isError = false;
      this.form.others_number = null
      this.ignitionEvent('blur', 'others_number')
    },
    onChangeFamilyStructure(e) {
      // 「生計人数: 1人（ご本人様のみ）」を選択時「お申込者と世帯主の関係: 本人」で固定
      if (e === 1) {
        this.form.householder_relation = '本人'
      }
    },
    // 世帯主の所得種類
    handleChangeHouseholderIncomeType(e) {
      if (e === 'その他') return
      // this.validationRules.householder_income_type_other_name_require.isError = false;
      this.form.householder_income_type_other_name = null
      this.ignitionEvent('blur', 'householder_income_type_other_name')
    },
    // 実家携帯電話の続柄
    handleChangeParentsPhoneRelationship(e) {
      if (e === 'その他') {
        this.form.parents_phone_relationship_other_name = null
        this.ignitionEvent('blur', 'parents_phone_relationship_other_name')
      }
      // 続柄の変更に応じて実家TELのエラー表示を再判定する（「その他」等の取り残し防止）
      this.parentsPhoneValidate()
    },
    // 実家固定電話チェックボックス変更（チェックを外した際に残存エラーを再判定）
    onToggleParentsPhone() {
      if (!this.form.parents_phone_exists) this.parentsPhoneValidate()
    },
    // 実家携帯電話チェックボックス変更（チェックを外した際に残存エラーを再判定）
    onToggleParentsMobile() {
      if (!this.form.parents_mobile_exists) this.parentsPhoneValidate()
    },
    // 住宅ローン・家賃のお支払い
    onChangeLoanRent() {
      this.ignitionEvent('blur', 'loan_rent')
    },
    /**
     * 現住所の"郵便番号"と"住所"の値を実家住所にコピー
     */
    handleAddressCopy() {
      if(this.parents_address_copy_flg) {
        this.form.parents_post = this.form.post_number
        this.form.parents_address = (this.form.street_address1 ?? '') + (this.form.street_address2 ?? '')
        return
      }
      this.form.parents_post = null
      this.form.parents_address = null
    },
    // 実家郵便番号検索
    onClickSearchParentPostNumber() {
      const result = document.getElementById('parents_post_search')
      axios
        .get(`/search-address?postcode=${this.form.parents_post}`)
        .then((res) => {
          this.form.parents_address = res.data.addr1 + res.data.addr2 + res.data.addr3
          result.value = true
          this.ignitionEvent('blur', 'parents_post_search')
          this.ignitionEvent('input', 'parents_post')
          this.ignitionEvent('input', 'parents_address')
          this.ignitionEvent('blur', 'parents_address')
        })
        .catch((res) => {
          // this.validationRules.parents_post_search.isError = true;
          result.value = false
          this.ignitionEvent('blur', 'parents_post_search')
        })
    },
    // 入社年月
    onChangeJoinDate(e) {
      this.ignitionEvent('blur', 'join_year')
      this.ignitionEvent('blur', 'join_month')
    },
    /**
     * お勤め先・学校について
     */
    onChangeOccupation() {
      const init = [
        'graduate_year',
        'graduate_month',
        'company_name',
        'company_name_kana',
        'company_phone1',
        'company_phone2',
        'company_phone3',
        'job_department',
        'dispatched_agent',
        'company_post',
        'company_address',
        'join_year',
        'join_month',
        'payday',
        'company_income',
        'sideline_type',
        'sideline_other_name',
        'sideline_income',
        'student_unemployed_flg',
        'company_job_description',
        'company_job_description_other_name'
      ]
      const has_payment = this.has_payment
      const occupation = this.form.occupation
      const installmentTerms = ['学生（アルバイト）', '専業主婦', '無職']
      const loop =
        (has_payment === 'credit' && occupation === '専業主婦') ||
        (has_payment !== 'credit' && installmentTerms.includes(occupation))
          ? init.length
          : 2

      for (let i = 0; i < loop; i++) {
        this.form[init[i]] = null
      }

      // 自社割賦の学生アルバイトをデフォルトでfalseにする処理
      if (has_payment === 'installment' && (occupation !== '学生（アルバイト）' || occupation !== '学生')) this.form.student_unemployed_flg = null

      // 卒業式の月をデフォルトで3月にする処理
      if (occupation === '学生（アルバイト）') this.form.graduate_month = '3'
    },
    // 仕事内容
    onChangeJobDescription(e) {
      if (e === 'その他') return
      this.form.company_job_description_other_name = null
      this.ignitionEvent('blur', 'company_job_description_other_name')
    },
    // 勤め先郵便番号検索
    onClickSearchCompanyPostNumber() {
      const result = document.getElementById('company_post_search')
      axios
        .get(`/search-address?postcode=${this.form.company_post}`)
        .then((res) => {
          this.form.company_address = res.data.addr1 + res.data.addr2 + res.data.addr3
          result.value = true
          this.ignitionEvent('blur', 'company_post_search')
          this.ignitionEvent('input', 'company_post')
          this.ignitionEvent('input', 'company_address')
          this.ignitionEvent('blur', 'company_address')
        })
        .catch((res) => {
          result.value = false
          // this.validationRules.company_post_search.isError = true;
          this.ignitionEvent('blur', 'company_post_search')
        })
    },
    // その他年収
    onChangeSidelineType(e) {
      if (e === 'その他') return
      // this.validationRules.sideline_other_name_require.isError = false;
      this.form.sideline_other_name = null
    },
    /**
     * 郵便番号にハイフンを追加処理
     * @param {event} e
     * @param {string} formKey
     */
    arrangeAddHyphen(e, formKey) {
      if (!e.srcElement.value || e.srcElement.value.match('-') || e.srcElement.value.length < 7) return
      this.form[formKey] = e.srcElement.value.slice(0, 3) + '-' + e.srcElement.value.slice(3, 7)
    },

    /**
     * 姓の自動カナ入力
     */
    handleSurnameInput() {
      setTimeout(() => {
        this.form.surname_kana = auto_surname_kana.elFurigana.value
      }, 0)
    },

    /**
     * 名の自動カナ入力
     */
    handleNameInput() {
      setTimeout(() => {
        this.form.first_name_kana = auto_first_name_kana.elFurigana.value
      }, 0)
    },

    /**
     * 旧姓の自動カナ入力
     */
    handleOldSurnameInput() {
      setTimeout(() => {
        this.form.old_surname_kana = auto_oldsurname_kana.elFurigana.value
      }, 0)
    },

    /**
     * 住所の自動カナ入力
     */
    handleStreetInput() {
      setTimeout(() => {
        this.form.street_address_kana = auto_street_address_kana.elFurigana.value
      }, 0)
    },

    /**
     * 会社名の自動カナ入力
     */
    handleCompanuyNameInput() {
      setTimeout(() => {
        this.form.company_name_kana = auto_company_name_kana.elFurigana.value
      }, 0)
    }
  },
  watch: {
    form: {
      async handler(newValue) {
        this.editUserInputFildes = EditUserInputFildes(this.has_payment, newValue, this.type)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/_variables.scss';
.head_data {
  text-align: center;
  font-size: 18px;
  border-bottom: 1px solid#eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.unemplyed_flg {
  font-size: 12px;
}
.fx {
  align-items: center;
  display: flex;
  label {
    margin-bottom: 0;
  }
  span {
    margin: 0 10px
  }
}
.mg_tb_10 {
  margin: 10px 0;
}
.camera {
  padding-top: 40px;

  .delete {
    opacity: 0.3;
  }

  &__item {
    width: 28%;
    height: 22vw;
    margin-bottom: 40px;
    border: 1px solid #d3d3d3;
    border-radius: 10px;
    padding: 5px;
    &:nth-child(3n + 1) {
      margin-left: 4%;
    }
    &:nth-child(3n - 1) {
      margin-left: 4%;
      margin-right: 4%;
    }
    &--inner {
      border: 1px solid #d3d3d3;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 5px;
      & a {
        text-align: center;
        display: inline-block;
      }
      & img {
        max-width: 90%;
        max-height: 21vw; // 規定の高さを入れる（可変）
        height: auto;
        vertical-align: bottom;
      }
    }
    &--add {
      border: 1px solid $--color-primary;
      & .camera__item--inner {
        background-color: #f8f8f8;
      }
    }
  }
  &__icon {
    font-size: 6vw;
  }
  &__txt {
    font-size: 2.5vw;
    margin: 0;
  }
}
.modal {
  &-wrap {
    width: 100%;
    height: 80vh;
    position: relative;
    & img {
      max-width: 100%;
      max-height: 80vh;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__img {
    position: relative;
    & i {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 3vw;
      cursor: pointer;
    }
  }
}
</style>
